import { BOARD_FILTER_SCOPE } from './filterScopeUtils';
import { buildEmAbertoFilterOptions } from './buildEmAbertoFilterOptions';
import { buildTechnicianFilterOptions } from './buildTechnicianFilterOptions';

const TECH_ONLY = new Set(['previsao', 'osFutura']);
const EM_ONLY = new Set(['status', 'tecnicoInicial']);

/** Listas de opções compartilhadas entre Em aberto e Técnicos (chave do item). */
const SHARED_COUNT_LISTS = [
  ['citiesWithCounts', 'cidade'],
  ['bairrosWithCounts', 'bairro'],
  ['clientesWithCounts', 'cliente'],
  ['tiposOSWithCounts', 'tipo'],
  ['slasWithCounts', 'sla'],
  ['equipamentosWithCounts', 'equipamento'],
  ['defeitoDescricaoWithCounts', 'value'],
  ['defeitoAlertWithCounts', 'value'],
  ['defeitoClassificationWithCounts', 'value'],
  ['defeitoSeverityWithCounts', 'value'],
];

function mergeCountList(emList = [], techList = [], idKey) {
  const map = new Map();
  const add = (list) => {
    (list || []).forEach((item) => {
      const id = item?.[idKey];
      if (id == null || String(id).trim() === '') return;
      const prev = map.get(id);
      const count = Number(item.count) || 0;
      if (!prev) {
        map.set(id, { ...item, count });
        return;
      }
      map.set(id, { ...prev, ...item, count: (Number(prev.count) || 0) + count });
    });
  };
  add(emList);
  add(techList);
  return [...map.values()].sort((a, b) => (Number(b.count) || 0) - (Number(a.count) || 0));
}

export function buildBoardSearchFilterOptions({
  scope,
  selectedColumnFilters,
  selectedTechnicianColumnFilters,
  emAbertoCounts,
  technicianCounts,
}) {
  const em = buildEmAbertoFilterOptions({
    selectedColumnFilters,
    ...emAbertoCounts,
  });
  const tech = buildTechnicianFilterOptions({
    selectedTechnicianColumnFilters,
    ...technicianCounts,
  });

  if (scope === BOARD_FILTER_SCOPE.EM_ABERTO) {
    return {
      filterOptions: em.filterOptions.map((o) =>
        o.key === 'retorno' ? { ...o, retornoMode: 'emAberto' } : o
      ),
      defeitoSubOptions: em.defeitoSubOptions,
    };
  }

  if (scope === BOARD_FILTER_SCOPE.TECNICOS) {
    return tech;
  }

  const clear = { key: 'clearAll', label: 'Limpar filtros', count: 0, isClearAction: true };
  const techMap = Object.fromEntries(tech.filterOptions.filter((o) => !o.isClearAction).map((o) => [o.key, o]));
  const emMap = Object.fromEntries(em.filterOptions.filter((o) => !o.isClearAction).map((o) => [o.key, o]));

  const keys = [
    'previsao',
    'retorno',
    'cidade',
    'bairro',
    'cliente',
    'tipoOS',
    'sla',
    'equipamento',
    'status',
    'tecnicoInicial',
    'defeitoSubmenu',
    'osFutura',
  ];

  const filterOptions = [
    clear,
    ...keys
      .map((key) => {
        if (TECH_ONLY.has(key)) return techMap[key];
        if (EM_ONLY.has(key)) return emMap[key];
        if (key === 'retorno') return techMap.retorno;
        return techMap[key] || emMap[key];
      })
      .filter(Boolean),
  ];

  return {
    filterOptions,
    defeitoSubOptions: tech.defeitoSubOptions,
  };
}

export function getCountsPropsForScope(scope, emAbertoCounts, technicianCounts) {
  if (scope === BOARD_FILTER_SCOPE.EM_ABERTO) {
    return { ...emAbertoCounts, previsaoWithCounts: [] };
  }
  if (scope === BOARD_FILTER_SCOPE.TECNICOS) {
    return {
      ...technicianCounts,
      statusWithCounts: [],
      tecnicoInicialWithCounts: [],
    };
  }
  const merged = {
    ...technicianCounts,
    statusWithCounts: emAbertoCounts.statusWithCounts || [],
    tecnicoInicialWithCounts: emAbertoCounts.tecnicoInicialWithCounts || [],
    previsaoWithCounts: technicianCounts.previsaoWithCounts || [],
  };
  SHARED_COUNT_LISTS.forEach(([prop, idKey]) => {
    merged[prop] = mergeCountList(emAbertoCounts[prop], technicianCounts[prop], idKey);
  });
  return merged;
}

export function isTechnicianOnlyFilterKey(key) {
  return TECH_ONLY.has(key);
}
